import images from "../../../utils/images";

const products = [
  {
    title: "سکه امامی",
    image: images.imamiCoin,
    changeRate: -1.344,
    price: 12360000,
    unit: "عدد",
    orderType: "purchase",
  },
  {
    title: "طلا آب شده",
    image: images.meltedGold,
    changeRate: 1.344,
    price: 1200000,
    unit: "گرم",
    orderType: "sale",
  },
  {
    title: "طلا ۱۸ عیار",
    image: images.eighteenCaratGold,
    changeRate: 12,
    price: 2140000,
    unit: "گرم",
    orderType: "purchase",
  },
  {
    title: "نیم سکه",
    image: images.halfCoin,
    changeRate: -8.5,
    price: 1950000,
    unit: "عدد",
    orderType: "sale",
  },
  {
    title: "ربع سکه",
  },
];

export default products;
